import * as React from 'react'
import './src/style.css'
import 'flag-icons/css/flag-icons.min.css'

import { ThemeProvider } from './src/context'

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)
